module.exports = __webpack_public_path__ + "img/symbol_5.37f9d7d8.png";